"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MenuContext = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(Object(source)); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var MenuContext = _react.default.createContext();

exports.MenuContext = MenuContext;

var MenuProvider = function (_PureComponent) {
  _inherits(MenuProvider, _PureComponent);

  function MenuProvider() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, MenuProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MenuProvider)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      isHowItWorksExpanded: false,
      isAboutCarvanaExpanded: false,
      isFinancingExpanded: false,
      isMobileMenuExpanded: false,
      isInDotCom: false
    };

    _this.setHowItWorksMenuState = function (isHowItWorksExpanded) {
      return _this.setState({
        isHowItWorksExpanded: isHowItWorksExpanded
      });
    };

    _this.setAboutCarvanaMenuState = function (isAboutCarvanaExpanded) {
      return _this.setState({
        isAboutCarvanaExpanded: isAboutCarvanaExpanded
      });
    };

    _this.setFinancingMenuState = function (isFinancingExpanded) {
      return _this.setState({
        isFinancingExpanded: isFinancingExpanded
      });
    };

    _this.setMobileMenuState = function (isMobileMenuExpanded) {
      return _this.setState({
        isMobileMenuExpanded: isMobileMenuExpanded
      });
    };

    return _this;
  }

  _createClass(MenuProvider, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      var state = this.state,
          setHowItWorksMenuState = this.setHowItWorksMenuState,
          setFinancingMenuState = this.setFinancingMenuState,
          setAboutCarvanaMenuState = this.setAboutCarvanaMenuState,
          setMobileMenuState = this.setMobileMenuState;
      return _react.default.createElement(MenuContext.Provider, {
        value: _objectSpread({}, state, {
          setHowItWorksMenuState: setHowItWorksMenuState,
          setFinancingMenuState: setFinancingMenuState,
          setAboutCarvanaMenuState: setAboutCarvanaMenuState,
          setMobileMenuState: setMobileMenuState
        }),
        "data-qa": "menu-provider"
      }, children);
    }
  }]);

  return MenuProvider;
}(_react.PureComponent);

exports.default = MenuProvider;